import { createElement } from "lucide";
import { resourceIcon, resourceChipClass, resourceOpensNewTab } from "./resource_config";
import escapeAttr from "./escape_attr";
import linkAttributes from "./link_attributes";

function iconSvg(type) {
  const icon = resourceIcon(type);
  return icon ? createElement(icon, { width: 12, height: 12 }).outerHTML : "";
}

export default function renderResourceChip(text, href, type) {
  const classes = resourceChipClass(type);
  const icon = iconSvg(type);
  // text can be user-supplied (context pill label/sublabel), so escape it before it hits innerHTML.
  const safeText = escapeAttr(text);
  if (!href) {
    return `<span class="${classes}">${icon}${safeText}</span>`;
  }
  const url = new URL(href, window.location.origin);
  const isInternal = url.origin === window.location.origin;
  const linkAttrs = linkAttributes({ inPlace: isInternal && !resourceOpensNewTab(type) });
  return `<a href="${escapeAttr(href)}"${linkAttrs} class="${classes}">${icon}${safeText}</a>`;
}
